// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Combos_AjustarResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract de POST /so/combos/ajustar (NS 2026-0090, fatia 5).
 *
 * O ajuste gravado (`movement_id`, `tipo` ajuste_credito | ajuste_debito),
 * a chave de idempotencia usada (a do pedido ou a gerada), `replay` = true
 * quando o pedido repetiu um ajuste ja gravado (nada novo foi escrito) e o
 * saldo da compra depois dele.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Combos_AjustarResponseDados {
combo_purchase_id: number
movement_id: number
tipo: string
idempotency_key: string
replay: boolean
quantidade: number
reservado: number
consumido: number
disponivel: number
}

export type Combos_AjustarResponse = ApiResponse<Combos_AjustarResponseDados>;

registerResponseContract('Combos_AjustarResponse', {
  combo_purchase_id: { type: 'number',  required: true },
  movement_id:       { type: 'number',  required: true },
  tipo:              { type: 'string',  required: true },
  idempotency_key:   { type: 'string',  required: true },
  replay:            { type: 'boolean', required: true },
  quantidade:        { type: 'number',  required: true },
  reservado:         { type: 'number',  required: true },
  consumido:         { type: 'number',  required: true },
  disponivel:        { type: 'number',  required: true },
})
